export const generateUniqueId = () => {
  return "id-" + Date.now() + "-" + Math.random().toString(36).substr(2, 9);
};

// TODO: Use Environment variables instead of this
// https://create-react-app.dev/docs/adding-custom-environment-variables/
//
// The explicit environment must win over NODE_ENV: `yarn build` always sets
// NODE_ENV=production, so checking it first made staging builds call the
// production API (REACT_APP_ENVIRONMENT comes from the Dockerfile / CI
// `react-env` input).
export const API_URLS = {
  production: "https://greedo-api.suggestic.com",
  staging: "https://greedo-api.staging.suggestic.com",
  development: "http://localhost:8000",
};

export const getApiUrl = (env = process.env) => {
  if (env.REACT_APP_API_URL) {
    return env.REACT_APP_API_URL;
  }
  if (env.REACT_APP_ENVIRONMENT === "staging") {
    return API_URLS.staging;
  }
  if (
    env.REACT_APP_ENVIRONMENT === "production" ||
    env.NODE_ENV === "production"
  ) {
    return API_URLS.production;
  }
  return API_URLS.development;
};

const utils = {
  API_URL: getApiUrl(),
};

export default utils;
